import { PromoFeatureName, PromoContent, PromoSize } from "./types";

const RELEASE_DATE = new Date("2026-01-30");
const FEATURE_FLAG_EXPIRY_DAYS = 32;
const USER_CREATION_CUTOFF_DAYS = 7;

export const FEATURE_FLAG_EXPIRY_DATE = new Date(
  RELEASE_DATE.getTime() + FEATURE_FLAG_EXPIRY_DAYS * 24 * 60 * 60 * 1000
);
export const USER_CREATION_CUTOFF_DATE = new Date(
  RELEASE_DATE.getTime() + USER_CREATION_CUTOFF_DAYS * 24 * 60 * 60 * 1000
);

const FULL_COMBINED_INCOME_PROMO_CONTENT: PromoContent = {
  imageSrc: "/assets/promo/combined-income.png",
  icons: [
    {
      src: "/assets/atomic_logo.svg",
      alt: "Atomic logo",
      width: 76,
      height: 20,
      classNames: "w-[76px] h-[20px]"
    },
    {
      src: "/assets/pinwheel_logo.svg",
      alt: "Pinwheel logo",
      width: 76,
      height: 20,
      classNames: "w-[76px] h-[20px]"
    },
    {
      src: "/assets/inscribe_logo.svg",
      alt: "Inscribe logo",
      width: 76,
      height: 22,
      classNames: "w-[64px] h-[22px]"
    },
    {
      src: "/assets/ocrolus_logo.svg",
      alt: "Ocrolus logo",
      width: 74,
      height: 22,
      classNames: "w-[74px] h-[22px]"
    }
  ],
  title: "Introducing Income Verification 2.0",
  subtitle:
    "A redesigned income verification experience that supports complex income scenarios. Now live for all of your screening templates.",
  description: "",
  bulletPoints: [
    "Verify multiple income sources within a single application",
    "Support bank, document, or payroll-based verification for each source",
    "Review income at the source level with clearer statuses and details",
    "Reduce manual follow-up with more accurate verification"
  ],
  actionButtonTitle: "Watch demo",
  actionButtonLink:
    "https://intercom.help/boomhelpcenter/en/articles/13517645-income-verification-2-0",
  onCloseClassNames: "w-[135px]"
};

export const PROMO_FEATURES: Record<
  PromoFeatureName,
  Record<PromoSize, PromoContent>
> = {
  [PromoFeatureName.CombinedIncome]: {
    [PromoSize.XS]: {
      ...FULL_COMBINED_INCOME_PROMO_CONTENT,
      imageSrc: "/assets/promo/combined-income-xs.png",
      icons: [],
      description: "",
      bulletPoints: [],
      onCloseClassNames: ""
    },
    [PromoSize.SM]: {
      ...FULL_COMBINED_INCOME_PROMO_CONTENT,
      description: ""
    },
    [PromoSize.BASE]: FULL_COMBINED_INCOME_PROMO_CONTENT
  }
};
